import getDevelopmentAlarmsStore from "../../../../stores/developer-store/development_alarms-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const TurnOffAlarmsForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        getDevelopmentAlarmsStore().getAlarmsOnFromDatabase();
      }}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});
export default TurnOffAlarmsForm;
